module.exports = __webpack_public_path__ + "img/cause2Red.1dec64b4.png";